import { render, staticRenderFns } from "./EditorFriend.vue?vue&type=template&id=7aaa9463"
import script from "./EditorFriend.vue?vue&type=script&lang=js"
export * from "./EditorFriend.vue?vue&type=script&lang=js"
import style0 from "./EditorFriend.vue?vue&type=style&index=0&id=7aaa9463&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports